export const getExpiresIn = (options) => {
    const date = new Date();
    if (options.days) {
        date.setDate(date.getDate() + options.days);
    }
    if (options.hours) {
        date.setHours(date.getHours() + options.hours);
    }
    if (options.minutes) {
        date.setMinutes(date.getMinutes() + options.minutes);
    }
    return date;
};
